import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const PauseIcon = (props) => (
  <SvgIcon width="19" height="18" viewBox="0 0 19 18" {...props}>
    <g>
      <path
        d="M6.5 3.5C5.67157 3.5 5 4.17157 5 5V13C5 13.8284 5.67157 14.5 6.5 14.5C7.32843 14.5 8 13.8284 8 13V5C8 4.17157 7.32843 3.5 6.5 3.5ZM12.5 3.5C11.6716 3.5 11 4.17157 11 5V13C11 13.8284 11.6716 14.5 12.5 14.5C13.3284 14.5 14 13.8284 14 13V5C14 4.17157 13.3284 3.5 12.5 3.5Z"
        transform="translate(-73.000000, -370.000000) translate(0.000000, -0.000000) translate(60.058594, 358.000000) translate(13.000000, 12.000000)"
      />
    </g>
  </SvgIcon>
);

export default PauseIcon;
